
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { onMounted } from "@vue/runtime-core";
import { getEmploymentList } from "@/api/http";
export default {
  components: {},
  setup() {
    const jobList = ref<any>([]);
    const router = useRouter();
    const gotoDetailPage = (job: any) => {
      localStorage.jobDetail = JSON.stringify(job);
      router.push("/joinDetail");
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      } else {
        document.body.scrollTop = 0;
      }
    };
    onMounted(() => {
      getEmploymentList().then((data) => {
        if (data.code === "0") {
          jobList.value = data.data;
        }
      });
    });
    return {
      jobList,
      gotoDetailPage,
    };
  },
};
